import React from 'react';

import AgentMcpToolsSection from '../AgentMcpToolsSection';
import { IntegrationsSettingsPanelProps } from './types';

export const IntegrationsSettingsPanel: React.FC<IntegrationsSettingsPanelProps> = ({
  agentId,
  agents,
  tools,
  refetch,
  disabled,
}) => (
  <AgentMcpToolsSection
    agentId={agentId}
    agents={agents}
    tools={tools}
    refetch={refetch}
    disabled={disabled}
  />
);
